import { isRouteErrorResponse, useRouteError } from 'react-router-dom'
import { Button, LinkButton } from '@/components/ui/Button'
import { ErrorState } from '@/components/ui/ErrorState'

/**
 * Last line of defence: a render or route-loading failure lands here instead of a
 * blank white page. Reload is offered because a failed lazy chunk (a deploy that
 * happened mid-session) is the most common cause and a reload genuinely fixes it.
 */
export function RouteErrorBoundary() {
  const error = useRouteError()

  const message = isRouteErrorResponse(error)
    ? `${error.status} ${error.statusText}`
    : error instanceof Error
      ? error.message
      : 'The screen could not be displayed.'

  return (
    <div className="flex min-h-dvh items-center justify-center bg-canvas p-4">
      <div className="w-full max-w-lg space-y-4">
        <ErrorState
          error={error}
          title="This screen failed to load"
          className="border-line bg-surface"
        />
        <p className="text-center text-xs text-ink-subtle">{message}</p>
        <div className="flex justify-center gap-2">
          <Button variant="secondary" onClick={() => window.location.reload()}>
            Reload
          </Button>
          <LinkButton to="/" variant="primary">
            Back to dashboard
          </LinkButton>
        </div>
      </div>
    </div>
  )
}
